"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = exports.StyledSelectArrow = exports.StyledEmptySelectOption = exports.StyledSelectOption = exports.StyledSelectPopover = exports.StyledSelectOptions = exports.StyledSelectButton = exports.StyledSelectInput = exports.StyledLabel = exports.StyledValue = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const listbox_1 = require("@reach/listbox");
exports.StyledValue = theme_1.styled.span `
  ${({ label }) => label &&
    (0, theme_1.css) `
      height: 100%;
      display: flex;
      align-items: flex-end;
      line-height: 26px;
      padding-bottom: 6px;
      box-sizing: border-box;
    `}

  ${({ isOverflowEllipsis, label }) => isOverflowEllipsis &&
    (0, theme_1.css) `
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline;
      ${label &&
        ` align-content: center;
        margin-top: 16px;
      `}
    `}
`;
exports.StyledLabel = theme_1.styled.div `
  ${theme_1.typography.regular12}
  color: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.text.secondary; }};
  line-height: 18px;
  letter-spacing: 0.12px;
  position: absolute;
  pointer-events: none;
  top: 4px;
  left: 16px;
`;
exports.StyledSelectInput = (0, theme_1.styled)(listbox_1.ListboxInput) `
  position: relative;
  border: 2px solid ${({ theme }) => theme.colors.neutral[10]};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : theme.common.radius; }};
  box-sizing: border-box;
  height: ${({ sizes, isSmall }) => sizes === 'small' || isSmall ? '28px' : '56px'};
  align-items: center;
  display: flex;
  transition: 300ms ease all;
  vertical-align: middle;
  overflow: hidden;
  background: ${({ theme }) => { var _a; return ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) ? 'transparent' : theme.colors.neutral[10]; }};

  &:hover {
    background: ${({ theme }) => { var _a; return !((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) && theme.colors.neutral[20]; }};
    border-color: ${({ theme }) => theme.colors.neutral[20]};
  }

  ${({ isValueFocused, status, theme }) => isValueFocused &&
    status !== 'error' &&
    (0, theme_1.css) `
      border-color: ${theme.colors.neutral[50]};
      background-color: ${theme.colors.neutral[0]};

      &:hover {
        background: ${theme.colors.neutral[0]};
        border-color: ${theme.colors.neutral[50]};
      }
    `}

  ${({ disabled, status, theme }) => {
    var _a, _b, _c;
    return disabled &&
        status !== 'error' &&
        (0, theme_1.css) `
      background: ${((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) ? 'transparent' : theme.colors.neutral[30]};
      border-color: ${((_b = theme.common) === null || _b === void 0 ? void 0 : _b.outlined)
            ? theme.colors.neutral[10]
            : theme.colors.neutral[30]};
      opacity: 1;
    }

    &:hover {
      background: ${!((_c = theme.common) === null || _c === void 0 ? void 0 : _c.outlined) && theme.colors.neutral[30]};
      border-color: ${theme.colors.neutral[30]};
    }
  
    &:disabled::placeholder,
    &:hover::placeholder {
      opacity: 0;
    }
  
    &:focus {
      &:hover::placeholder {
        opacity: 1;
      }
    }
  
    &::placeholder,
    &:disabled {
      user-select: none;
      color: ${theme.colors.neutral[50]};
      -webkit-text-fill-color: ${theme.colors.neutral[50]};
      border: none;
    }
  
    &::placeholder {
      -webkit-text-fill-color: transparent;
    }
  
    &:hover::placeholder {
      -webkit-text-fill-color: ${theme.colors.text.secondary};
    `;
}}

    ${({ status, theme }) => status === 'error' &&
    (0, theme_1.css) `
      border-color: ${theme.colors.accent.error.normal};
      background-color: ${theme.colors.accent.error.faded};
      &:hover {
        border-color: ${theme.colors.accent.error.normal};
        background-color: ${theme.colors.accent.error.faded};
      }
    `}
    ${({ isSmall, sizes }) => (isSmall || sizes === 'medium' || sizes === 'small') &&
    (0, theme_1.css) `
      min-width: 68px;
      width: auto;
      display: inline-block;
      height: 28px;
      ${sizes === 'small' ? theme_1.typography.regular14 : theme_1.typography.regular18};
    `}
`;
exports.StyledSelectButton = (0, theme_1.styled)(listbox_1.ListboxButton) `
  ${({ sizes }) => sizes === 'small' ? theme_1.typography.regular14 : theme_1.typography.regular18};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.primary};
  justify-content: space-between;
  padding: ${({ sizes }) => (sizes === 'small' ? '0 12px' : '0 16px 0 18px')};
  cursor: default;
  user-select: none;
  height: ${({ sizes, isSmall }) => sizes === 'small' || sizes === 'medium' || isSmall ? '24px' : '56px'};
  outline: none;
  margin: 0 -2px;

  & > [data-reach-listbox-arrow] {
    line-height: 0;
  }

  ${({ disabled, theme }) => disabled &&
    (0, theme_1.css) `
      path {
        fill: ${theme.colors.neutral[70]};
      }
    `}
`;
exports.StyledSelectOptions = (0, theme_1.styled)(listbox_1.ListboxList) `
  list-style: none;
  padding: 0;

  svg {
    width: 16px;
    path {
      stroke: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.interactive; }};
    }
  }
`;
exports.StyledSelectPopover = (0, theme_1.styled)(listbox_1.ListboxPopover) `
  ${({ theme }) => theme.common['box-shadow']};
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : theme.common.radius; }};
  box-sizing: border-box;
  transform: translateY(8px);
  z-index: 10;
  > [data-reach-listbox-list] {
    display: flex;
    flex-direction: column;
    max-height: 40vh;
    overflow: auto;
    outline: none;
    margin: 12px 0;
  }
`;
exports.StyledSelectOption = (0, theme_1.styled)(listbox_1.ListboxOption) `
  ${({ sizes }) => sizes === 'small' ? theme_1.typography.regular14 : theme_1.typography.regular18};
  line-height: 24px;
  cursor: pointer;
  color: ${({ theme, isSelected }) => { var _a, _b; return isSelected && ((_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.interactive); }};
  padding: ${({ sizes }) => (sizes === 'small' ? '0px 16px' : '8px 16px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral['10']};
  }
`;
exports.StyledEmptySelectOption = theme_1.styled.span `
  cursor: pointer;
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
`;
exports.StyledSelectArrow = (0, theme_1.styled)(listbox_1.ListboxArrow) `
  flex-grow: 1;

  ${({ isOverflowEllipsis }) => isOverflowEllipsis &&
    `width: 100%;
  & > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }`}
`;
exports.Placeholder = theme_1.styled.span `
  color: ${({ status, disabled, theme }) => {
    var _a;
    return status === 'error'
        ? theme.colors.text.error
        : disabled && ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
            ? theme.colors.text.tertiary
            : theme.colors.text.secondary;
}};
`;
